import { View, StyleSheet } from "react-native";
import { useTheme } from '@react-navigation/native';
import { createCommonStyles } from "../../../../styles/commonStyles";
import { useTranslation } from 'react-i18next';
import CustomLabel from "../../../../components/CustomLabel/CustomLabel";
import CustomControlledInput from "../../../../components/ControlledComponents/CustomControlledInput";
import { CONTROL_FORM_FIELDS } from "../../../../constants/ControlFormFields";

const HRAdminChangeEmplId = (props) => {
    const { colors } = useTheme();
    const common = createCommonStyles(colors);
    const { t } = useTranslation();
    const styles = makeStyles(colors);
    //* Control names imported from const file
    const { EMPLOYEEIDINPUT } = CONTROL_FORM_FIELDS.CHANGEEMPLOYEEID;

    return (
        <View style={[common.cardstyle, styles.mainView]}>
            <CustomLabel type='MINORTITLE' value={t('common:changeEmplId')} fontSize={18} />
            {/* // * No empty check, this field is not required  */}
            <CustomControlledInput
                name={EMPLOYEEIDINPUT}
                control={props.control}
                type={'MAININPUT'}
                maxLen={9}
                rules={{
                    validate: (value) => {
                        return value !== props?.selectedEmployee?.employeeID || t('common:emplIdSameErr');
                    }
                }}
            />
        </View >
    )
}

const makeStyles = (colors) =>
    StyleSheet.create({
        mainView: {
            padding: 15,
        },
    })

export default HRAdminChangeEmplId;